import { createStore } from 'vuex';
import { EventEmitter } from 'events';
import { AuthorizedUser } from '../models/authorized-user';
import snackBarStoreModule from '@/shared/components/snackbar/snack-bar-store-module';
import trustMemberStoreModule from './trust-member-store.module';
import investigationStoreModule from './investigation-store-module';

export default createStore({
  modules: {
    trustMemberStoreModule,
    snackBarStoreModule,
    investigationStoreModule,
  },
  state: {
    authorizedUser: new AuthorizedUser(),
    eventController: new EventEmitter(),
  },
  mutations: {
    setUserAccount(state, authorizedUser: AuthorizedUser) {
      state.authorizedUser = authorizedUser;
    },
  },
  actions: { // store.dispatch
    setUserAccount({ commit }, authorizedUser: AuthorizedUser) {
      commit('setUserAccount', authorizedUser);
    }
  },
  getters: {
    getUserAccount: (state) => state.authorizedUser,
    getEventController: (state) => state.eventController,
  }
})
